import { render } from "./ProposalModalNumberInput.vue?vue&type=template&id=fb553660&scoped=true"
import script from "./ProposalModalNumberInput.vue?vue&type=script&lang=ts"
export * from "./ProposalModalNumberInput.vue?vue&type=script&lang=ts"

import "./ProposalModalNumberInput.vue?vue&type=style&index=0&id=fb553660&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fb553660"

export default script